import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Form, { InputNumber, Submit, Cancel, Checkbox } from "../../../components/Form";

import { FlexForm } from "../styles";

import messages from "./messages";
import { IProps } from "./interfaces";

const FormKey = ({
    loading,
    keyValidation,
    teacherKey,
    saveKey,
    changeKey,
    handleChangeSaveKey,
    submitKey,
}: IProps) => {
    const { formatMessage } = useIntl();
    return (
        <Form disabled={loading}>
            <FlexForm>
                <InputNumber
                    name="teacherKey"
                    validation={keyValidation}
                    value={teacherKey}
                    disabled={loading}
                    onChange={changeKey}
                    label={formatMessage(messages.key)}
                />
                <Checkbox
                    label={formatMessage(messages.rememberKey)}
                    checked={saveKey}
                    onChange={handleChangeSaveKey}
                    disabled={loading}
                />
                <Submit onClick={submitKey} loading={loading}>
                    <FormattedMessage {...messages.next} />
                </Submit>
                <Cancel className="FakeBack" onClick={() => null}>
                    <FormattedMessage {...messages.back} />
                </Cancel>
            </FlexForm>
        </Form>
    );
};

export default FormKey;
